import type { MessageDescriptor } from 'react-intl';

import type { PriceSegmentation, ProductId } from '../../../../services/modal-data/types';
import { messages } from './messages';

type HeadingText = {
	headingBreak?: MessageDescriptor;
	message: MessageDescriptor;
	noAddedCost?: boolean;
};

/**
 * Determines the appropriate heading message and values based on pricing and products
 */
export const getHeadingText = (
	priceSegmentation: PriceSegmentation,
	userProducts: ProductId[],
	isConfluenceWithoutJiraEnabled: boolean = false,
): HeadingText => {
	const hasJira = userProducts.includes('jira');
	const hasConfluence = userProducts.includes('confluence');
	if (priceSegmentation !== 'increase' && hasJira && hasConfluence) {
		return {
			message: messages.headingNoPriceIncrease,
			noAddedCost: true,
		};
	}

	const hasLoom = userProducts.includes('loom');
	if (hasJira && hasLoom && userProducts.length === 2) {
		return {
			message: messages.headingJiraAndLoom,
			headingBreak: messages.headingDocs,
		};
	}

	if (hasJira && userProducts.length === 1) {
		return {
			message: messages.headingJiraOnly,
			headingBreak: messages.headingAIPowered,
		};
	}

	if (isConfluenceWithoutJiraEnabled && hasConfluence && userProducts.length === 1) {
		return {
			message: messages.headingConfluenceOnly,
			headingBreak: messages.headingAIPowered,
		};
	}

	return {
		message: messages.headingPriceIncrease,
		headingBreak: messages.headingVideo,
	};
};
